module.exports = __webpack_public_path__ + "static/media/IMG_0768.726fa527.JPG";